"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProfileSubscriptions = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const ui_kit_1 = require("@dzambalaorg/ui-kit");
const ProfileSubscriptions = (props) => {
    const { open } = props;
    if (!open) {
        return null;
    }
    return (0, jsx_runtime_1.jsx)(ui_kit_1.Typography, { children: "You are not subscribed..." });
};
exports.ProfileSubscriptions = ProfileSubscriptions;
//# sourceMappingURL=index.js.map